import React, { Suspense, lazy } from 'react'
import { LoadingLogo } from '@/components/atoms/LoadingLogo/LoadingLogo'
import PageWrapper from '@/components/organisms/PageWrapper/PageWrapper'

// Carga los componentes de manera dinámica y especifica la importación de 'default'
const Header = lazy(
  async () =>
    await import('@/components/organisms/Header/Header').then((module) => ({
      default: module.default
    }))
)
const BannerHome = lazy(
  async () =>
    await import('@/components/templates/Bussines/BannerHome/BannerHome').then((module) => ({
      default: module.default
    }))
)
const Services = lazy(
  async () =>
    await import('@/components/templates/Bussines/Services/Services').then((module) => ({
      default: module.default
    }))
)
const WhyChooseUs = lazy(
  async () =>
    await import('@/components/templates/Bussines/WhyChooseUs/WhyChooseUs').then((module) => ({
      default: module.default
    }))
)
const CallToAction = lazy(
  async () =>
    await import('@/components/templates/Bussines/CallToAction/CallToAction').then((module) => ({
      default: module.default
    }))
)
const Testimonials = lazy(
  async () =>
    await import('@/components/templates/Bussines/Testimonials/Testimonials').then((module) => ({
      default: module.default
    }))
)
// const AboutUs = lazy(async () => await import('@/components/templates/Bussines/AboutUs/AboutUs').then(module => ({ default: module.default })))
const ContactForm = lazy(
  async () =>
    await import('@/components/templates/Bussines/ContactForm/ContactForm').then((module) => ({
      default: module.default
    }))
)
const Footer = lazy(
  async () =>
    await import('@/components/organisms/Footer/Footer').then((module) => ({
      default: module.default
    }))
)

export const Bussines: React.FC = () => {
  const buildDate = new Date().toISOString()

  return (
    <PageWrapper
      title="Basciano Trading Corporation | Bussines"
      description="A strategic ally in the simplification and optimization of administrative processes."
      url="https://www.basciano.com/bussines"
      keywords={[
        'Basciano Trading Corporation',
        'Bussines',
        'Payments',
        'Optimization',
        'Simplification',
        'Business solutions',
        'Strategic ally',
        'Global business',
        'Customs clearance',
        'Compliance',
        'Trade finance'
      ]}
      language="en"
      publishedTime={buildDate}
    >
      <Suspense fallback={<LoadingLogo />}>
        <div className="min-h-screen flex flex-col overflow-hidden">
          <Header isNotHome />
          <main className="flex-grow">
            <section id="home">
              <BannerHome />
            </section>
            <section id="services">
              <Services />
            </section>
            <section id="chooseUs">
              <WhyChooseUs />
            </section>
            <section id="callToAction">
              <CallToAction />
            </section>
            <section id="testimonials">
              <Testimonials />
            </section>
            {/* <section id='aboutUs'>
              <AboutUs />
            </section> */}
            <section id="contact">
              <ContactForm />
            </section>
          </main>
          <Footer />
        </div>
      </Suspense>
    </PageWrapper>
  )
}
